<template>
    <v-container class="fill-height"
                 fluid>
        <v-row align="center"
               justify="center">
            <v-col class="text-center">
                 <div> Welcome, use left navigation to move around. </div>

                 
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Home',
 
  }
</script>
